"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.NotificationsIcon = (0, react_1.forwardRef)(function NotificationsIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M11.1389 2.16985C11.2731 2.0599 11.4413 1.99987 11.6148 2H12.3848C12.5583 1.99987 12.7264 2.0599 12.8606 2.16985C12.9948 2.2798 13.0868 2.43287 13.1208 2.603L13.2628 3.315C13.3057 3.52959 13.3951 3.73219 13.5247 3.90856C13.6543 4.08494 13.8208 4.23083 14.0128 4.336L14.3128 4.5C15.1936 4.90048 15.9554 5.52292 16.5233 6.30633C17.0913 7.08975 17.446 8.00726 17.5528 8.969L18.0928 13.834C18.1427 14.2822 18.282 14.7159 18.5023 15.1094C18.7227 15.5029 19.0197 15.8482 19.3758 16.125L19.7288 16.4C19.9584 16.5784 20.1312 16.8197 20.2262 17.0945C20.3212 17.3694 20.3342 17.6659 20.2638 17.948L20.2498 18C20.1784 18.2855 20.0137 18.539 19.7818 18.7202C19.5499 18.9014 19.2641 18.9999 18.9698 19H15C15 19.7956 14.6839 20.5587 14.1213 21.1213C13.5587 21.6839 12.7956 22 12 22C11.2044 22 10.4413 21.6839 9.87868 21.1213C9.31607 20.5587 9 19.7956 9 19H5.02977C4.42477 19 3.89677 18.588 3.74977 18L3.73677 17.948C3.66619 17.666 3.67909 17.3695 3.77389 17.0947C3.8687 16.8199 4.04132 16.5785 4.27077 16.4L4.62477 16.125C4.98066 15.8481 5.27747 15.5028 5.49766 15.1093C5.71785 14.7158 5.85695 14.2821 5.90677 13.834L6.44677 8.97C6.55333 8.00809 6.90798 7.09036 7.47596 6.30676C8.04393 5.52316 8.80576 4.90057 9.68677 4.5L9.98677 4.335C10.1786 4.22994 10.3451 4.0842 10.4747 3.90801C10.6042 3.73181 10.6937 3.52941 10.7368 3.315L10.8788 2.603C10.9128 2.43287 11.0047 2.2798 11.1389 2.16985Z", fill: "currentColor" })));
});
